module.exports = __webpack_public_path__ + "static/media/mcamob.cedbe85d.jpg";